export default __webpack_public_path__ + "static/media/First Bishops of CSI 2.d8658a68.jpg";